import request from '../utils/request';
// 走进王道

//招聘数据列表-加入我们type:类型(0:考研，1：训练营)
export const getRecruitmentList = type => {
    return request({
        url: `/admin/recruitment_info/list/${type}`,
        method: 'get',
    });
};
//发展历史数据列表无分页
export const getHistoryList = () => {
    return request({
        url: '/admin/history/list',
        method: 'get',
    });
};
//联系我们
export const getTalkUsList = () => {
    return request({
        url: '/admin/contact_information/list',
        method: 'post',
    });
};
//查询学习环境
export const getLearnList = params => {
    return request({
        url: '/training_camp/course_introduction/learning_environmentImg',
        method: 'post',
        data: params
    });
};